import { useMemo } from 'react'
import { useTheme } from '@mui/material'
import { useSceneShapeMarker } from '@editorHooks'
import { ClipPlanePreset, getPresetClipPlaneOutlinePoints } from './utils'

interface Props {
  preset: ClipPlanePreset
}

const ClipPlanePresetPreview = ({ preset }: Props): null => {
  const { scenePalette } = useTheme()
  const points = useMemo(() => getPresetClipPlaneOutlinePoints(preset), [preset])

  useSceneShapeMarker({
    points,
    enabled: true,
    color: scenePalette.highlightDark as string,
    lineWidth: 2,
    renderOrder: 101,
  })

  return null
}

export default ClipPlanePresetPreview
